import { useEffect, useState } from "react";
import { SITE } from "../data/site";

// Titles/descriptions the team applied from the back office (loaded once per visit).
let overridesPromise;
const loadOverrides = () => {
  if (!overridesPromise) {
    const base = process.env.REACT_APP_BACKEND_URL;
    overridesPromise = base
      ? fetch(`${base}/api/seo/overrides`).then((r) => (r.ok ? r.json() : {})).catch(() => ({}))
      : Promise.resolve({});
  }
  return overridesPromise;
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

// Per-page title, description, canonical, social tags and JSON-LD.
export const Seo = ({ title: baseTitle, description: baseDescription, path = "/", jsonld, noindex = false }) => {
  const ld = jsonld ? JSON.stringify(jsonld) : "";
  const [override, setOverride] = useState(null);
  useEffect(() => {
    let live = true;
    loadOverrides().then((map) => { if (live) setOverride(map?.[path] ?? null); });
    return () => { live = false; };
  }, [path]);
  const title = override?.title || baseTitle;
  const description = override?.description || baseDescription;
  useEffect(() => {
    const url = `${SITE}${path}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;
    const old = document.getElementById("route-jsonld");
    if (old) old.remove();
    if (ld) {
      const s = document.createElement("script");
      s.type = "application/ld+json"; s.id = "route-jsonld"; s.text = ld;
      document.head.appendChild(s);
    }
  }, [title, description, path, ld, noindex]);
  return null;
};

export const BUSINESS_ID = `${SITE}/#business`;

export const faqLd = (faqs) => ({
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

export const crumbsLd = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE}${path}` })),
});
